// 外部套件
import 'jquery/src/jquery.js'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

// 原始套件
import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

// 城市載入

createApp(App).use(store).use(router).mount('#app');
